module.exports = __webpack_public_path__ + "static/media/screensaver.3b97ebc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screensaver.jpg
// module id = 379
// module chunks = 0